<h1 class="text-center text-primary">Downloads</h1>
<br/>
<div class="row">
  @for (line of downloads$ | async; track line) {
    <div class="col-4">
      <div class="card" style="width: 18rem;">
        <div class="text-center">
          <img
            src="../../../assets/{{line.fileType}}-icon.png"
            alt="..."
            width="150"
            />
          </div>
          <div class="card-body">
            <h5 class="card-title">{{line.title}}</h5>
            <p class="card-text">
              {{line.detail}}
            </p>
            <a href="{{baseUrl}}{{line.number}}" class="btn btn-primary" >Download</a>
          </div>
        </div>
      </div>
    }
  </div>



